import { inputStyles } from "../styles/styles";

import React, { useState, useEffect, useRef } from "react";
import BaseWindow from "./public/BaseWindow";
import {
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormHelperText,
  Link,
  InputAdornment,
  IconButton,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import { PhoneNumberMask, TCKNMask, VKNMask } from "./public/TextMask";
import { connect } from "react-redux";
import NotFoundPage from "./public/NotFoundPage";
import { updateCustomerInfo } from "../store/customerInformation/actions";
import DatePicker from "./public/DatePicker";
import {
  getNextStep,
  getNumberFormat,
  getProductTypeString,
  linksStates,
  getFirmRedirectUrlFromShopUrl,
} from "../utils/enums.ts";
import InfoIcon from "@material-ui/icons/Info";

import { useHistory, useParams } from "react-router-dom";
import BaseTextField from "./public/BaseTextField";
import { bindActionCreators } from "redux";
import { sendApplicantCompany } from "../store/customerInformation/thunkActions";
import { getErrorMessage, stateHandler } from "../utils/enums";
import {
  updateUnsuccessMsg,
  updateUnsuccessRedirectUrl,
} from "../store/unsuccess/actions";
import { addProcessContext } from "../store/processContext/actions";
import OtpModal from "./public/OtpModal";
import { generateOTPApplicant } from "../store/global/thunkActions";

import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { updateAlert } from "../store/alert/actions";
import { getProductInfo } from "../store/limitAndPaymentInformation/thunkActions";

function LimitedStep1(props) {
  const classes = inputStyles();
  let history = useHistory();
  let { uuid } = useParams();
  const pageName = "limitedStep1";
  const linkRef = useRef();

  const inputDataDefaultState = {
    appType: {
      value: "1",
      error: false,
      helperText: "",
    },
    tckn: {
      value: "",
      error: false,
      helperText: "",
    },
    taxNo: {
      value: "",
      error: false,
      helperText: "",
    },
    phone: {
      value: "",
      error: false,
      helperText: "",
    },
    email: {
      value: "",
      error: false,
      helperText: "",
    },
    birthDate: {
      value: null,
      error: false,
      helperText: "",
    },
    kisiselVerilerCheckBox: {
      value: false,
      error: false,
      helperText: "",
    },
  };
  const [inputData, setInputData] = useState(inputDataDefaultState);
  const [kvkkEnabled, setKvkkEnabled] = useState(false);

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpType, setOtpType] = useState("");

  useEffect(() => {
    if (props.customerInformations) {
      inputDataChange("tckn", props.customerInformations.tckn || "");
      inputDataChange(
        "birthDate",
        props.customerInformations.birthDate || null,
        "date",
      );
      inputDataChange("phone", props.customerInformations.phoneNumber || "");
      inputDataChange("email", props.customerInformations.email || "");
      inputDataChange("appType", props.customerInformations.appType || "1");
      if (props.customerInformations.appType === "2") {
        inputDataChange("taxNo", props.customerInformations.taxNo || "");
      }
    }

    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        devamClick();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  const inputDataChange = (propName, value, type) => {
    let setVal = value;
    switch (type) {
      case "date":
        setVal = value && value !== "" ? new Date(value) : null;
        break;
      default:
        setVal = value;
        break;
    }
    setInputData((prevState) => {
      return {
        ...prevState,
        [propName]: {
          value: setVal,
          error: prevState[propName].error,
          helperText: prevState[propName].helperText,
        },
      };
    });
  };

  const setInputDataErrorChange = (
    prevState,
    propName,
    equalVal,
    helperText,
    type,
  ) => {
    let compairingVal = "";
    switch (type) {
      case "length":
        compairingVal = prevState[propName].value.length;
        break;
      case "indexOf":
        compairingVal = prevState[propName].value.indexOf("@") !== -1;
        break;
      case "null":
        compairingVal = prevState[propName].value === null;
        break;
      default:
        compairingVal = prevState[propName].value;
        break;
    }
    if (compairingVal !== equalVal) {
      return {
        ...prevState,
        [propName]: {
          value: prevState[propName].value,
          error: true,
          helperText,
        },
      };
    } else {
      if (type !== "null") {
        return {
          ...prevState,
          [propName]: {
            value: prevState[propName].value,
            error: false,
            helperText: "",
          },
        };
      } else {
        return prevState;
      }
    }
  };

  const validationCheck = () => {
    let valid = true;

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "tckn",
        11,
        getErrorMessage("MS0003"),
        "length",
      );

      if (inputData.appType === "2") {
        prevState = setInputDataErrorChange(
          prevState,
          "taxNo",
          10,
          getErrorMessage("MS0003"),
          "length",
        );
      }

      prevState = setInputDataErrorChange(
        prevState,
        "phone",
        10,
        getErrorMessage("MS0004"),
        "length",
      );
      prevState = setInputDataErrorChange(
        prevState,
        "birthDate",
        false,
        getErrorMessage("MS0005"),
        "null",
      );
      prevState = setInputDataErrorChange(
        prevState,
        "email",
        true,
        "Geçerli Bir Email giriniz",
        "indexOf",
      );
      prevState = setInputDataErrorChange(
        prevState,
        "kisiselVerilerCheckBox",
        true,
        getErrorMessage("MS0006"),
        "checked",
      );

      Object.keys(prevState).forEach((key) => {
        if (prevState[key].error) {
          valid = false;
        }
      });

      return prevState;
    });

    return valid;
  };

  const validationCheck4PhoneVerify = () => {
    let valid = true;

    // Senkron validasyon - setState öncesi kontrol
    if (!inputData.birthDate.value) {
      valid = false;
    }
    if (inputData.tckn.value?.length !== 11) {
      valid = false;
    }
    if (inputData.phone.value?.length !== 10) {
      valid = false;
    }

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "tckn",
        11,
        getErrorMessage("MS0003"),
        "length",
      );
      prevState = setInputDataErrorChange(
        prevState,
        "phone",
        10,
        getErrorMessage("MS0004"),
        "length",
      );
      prevState = setInputDataErrorChange(
        prevState,
        "birthDate",
        false,
        getErrorMessage("MS0005"),
        "null",
      );

      return prevState;
    });

    return valid;
  };

  const validationCheck4MailVerify = () => {
    let valid = true;

    setInputData((prevState) => {
      prevState = setInputDataErrorChange(
        prevState,
        "tckn",
        11,
        getErrorMessage("MS0003"),
        "length",
      );
      prevState = setInputDataErrorChange(
        prevState,
        "email",
        true,
        getErrorMessage("MS0025"),
        "indexOf",
      );

      Object.keys(prevState).forEach((key) => {
        if (prevState[key].error) {
          valid = false;
        }
      });

      return prevState;
    });

    return valid;
  };

  const verifyWithOtp = (otpType) => {
    const birthDate = inputData.birthDate.value;

    // Doğum tarihi kontrolü
    if (!birthDate) {
      setInputData((prevState) => ({
        ...prevState,
        birthDate: {
          ...prevState.birthDate,
          error: true,
          errorMessage: getErrorMessage("MS0005"),
        },
      }));
      return;
    }

    const birthDateString =
      birthDate.getFullYear() +
      ("0" + (birthDate.getMonth() + 1)).slice(-2) +
      ("0" + birthDate.getDate()).slice(-2);
    let body = {
      nationalIdentityNo: inputData.tckn.value,
      validateMobileNumber: "1",
      otpType,
      birthDate: birthDateString,
      externalId: uuid,
    };

    switch (otpType) {
      case "SMS":
        if (!validationCheck4PhoneVerify()) {
          return;
        }
        body = {
          ...body,
          mobileNumber: inputData.phone.value,
        };
        break;
      case "MAIL":
        if (!validationCheck4MailVerify()) {
          return;
        }
        body = {
          ...body,
          mail: inputData.email.value,
        };
        break;
      default:
        return;
    }

    //setOtpModalOpen(true);

    props.actions.generateOTPApplicant(body).then((res) => {
      if (res === true) {
        setOtpType(otpType);
        setOtpModalOpen(true);
      }
    });
  };

  const temizleClick = () => {
    setInputData(inputDataDefaultState);
    props.actions.updateCustomerInfo({
      phoneValidationCheck: false,
      mailValidationCheck: false,
    });
  };

  const devamClick = (e) => {
    if (validationCheck()) {
      if (!props.customerInformations.phoneValidationCheck) {
        props.actions.updateAlert({
          severity: "error",
          text: "Devam etmeden önce cep telefonunuzu doğrulayınız",
          open: true,
        });
      } else {
        callService();
      }
      //history.push(getNextStep(pageName));
    } else {
      props.actions.updateAlert({
        severity: "error",
        text: "Validasyon Hatası.",
        open: true,
      });
    }
  };

  const callService = () => {
    const appType = inputData.appType.value;
    const taxNo = appType === "2" ? inputData.taxNo.value : "";
    const tckn = inputData.tckn.value;
    const phone = inputData.phone.value;
    const birthDate = inputData.birthDate.value;
    const email = inputData.email.value;
    const birthDateString =
      birthDate.getFullYear() +
      ("0" + (birthDate.getMonth() + 1)).slice(-2) +
      ("0" + birthDate.getDate()).slice(-2);

    const requestBody = {
      companyCode: props.processContext.companyCode,
      agencyCode: props.processContext.agencyCode,
      nationalIdentityNo: tckn,
      mobilePhone: phone,
      birthDate: birthDateString,
      referenceNo: props.processContext.referenceNo,
      email: email,
      emailValid: props.customerInformations?.mailValidationCheck ? "1" : "0",
      externalId: uuid,
      otpOID: props.global.otpInfo?.otpOID,
      appType,
      taxNo,
    };

    props.actions.updateCustomerInfo({
      tckn: tckn,
      phoneNumber: phone,
      birthDate: birthDate,
      email: inputData.email.value,
      appType,
      taxNo,
    });

    props.actions.updateUnsuccessRedirectUrl(null);

    props.actions.sendApplicantCompany(requestBody).then((res) => {
      const result = stateHandler(res.appState);

      if (result === undefined) {
        props.actions.updateUnsuccessRedirectUrl(null);
        return;
      }

      const firmRedirectUrl = getFirmRedirectUrlFromShopUrl(res.shopUrl);

      const shouldShowFirmButton =
        result?.result !== "0" &&
        firmRedirectUrl &&
        (res.appState === linksStates.REFUSE ||
          res.appState === linksStates.LIMIT_NOT_ENOUGH);

      props.actions.updateUnsuccessRedirectUrl(
        shouldShowFirmButton ? firmRedirectUrl : null,
      );

      if (result?.result !== "0") {
        /*  Limit yetersiz mesajında limit bilgisini de gösterebilmek için eklendi!! */
        if (
          res.appState === linksStates.LIMIT_NOT_ENOUGH &&
          res.limitAmount !== undefined &&
          res.limitAmount !== null
        ) {
          props.actions.updateUnsuccessMsg(
            "Onaylanan limitiniz  " +
              getNumberFormat(res.limitAmount) +
              " TL'dir. Bu tutar sepetiniz için yeterli değildir. " +
              "Sepet tutarınızı güncelleyerek yeniden deneyebilirsiniz.",
          );
        } else if (res.appState === linksStates.LIMIT_NOT_ENOUGH) {
          props.actions.updateUnsuccessMsg(getErrorMessage("MS0001"));
        } else if (res.appState === linksStates.HOLD) {
          props.actions.updateUnsuccessMsg(getErrorMessage("MS0027"));
        } else {
          props.actions.updateUnsuccessMsg(
            result.errorCode ? getErrorMessage(result.errorCode) : result.msg,
          );
        }
      }

      const nextStepName = getNextStep(pageName, result.result);
      props.actions.addProcessContext({ stepName: nextStepName });
      history.push("/" + uuid + "/" + nextStepName);
    });
  };

  return props.processContext.stepName !== pageName ? (
    <NotFoundPage />
  ) : (
    <BaseWindow isBasket={true}>
      <OtpModal
        open={otpModalOpen}
        setOpen={setOtpModalOpen}
        setOtpVerified={setOtpVerified}
        otpType={otpType}
        tckn={inputData.tckn.value}
        uuid={uuid}
      />
      <Grid item xs={12}>
        <p className={classes.label}>
          Ödemenizi Fibabanka{" "}
          {getProductTypeString(props.processContext?.productType)} Kredisi ile
          gerçekleştirmek için aşağıdaki alanları doldurunuz.
        </p>
      </Grid>

      {props.processContext?.productType !== "0" && (
        <Grid item xs={12}>
          <RadioGroup
            row
            value={inputData.appType.value}
            onChange={(ev) => inputDataChange("appType", ev.target.value)}
          >
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label="Şahıs İşletmesi/ Esnaf "
              classes={{
                label: classes.label,
              }}
            />
            <FormControlLabel
              value="2"
              control={<Radio color="primary" />}
              label="Tüzel Firma (Limited)"
              classes={{
                label: classes.label,
              }}
            />
          </RadioGroup>
        </Grid>
      )}
      {inputData.appType.value === "2" && (
        <Grid item xs={12}>
          <p className={classes.p}>{"Vergi Kimlik Numarası"} </p>
          <BaseTextField
            error={inputData.taxNo.error}
            helperText={inputData.taxNo.helperText}
            value={inputData.taxNo.value}
            onChange={(ev) => inputDataChange("taxNo", ev.target.value)}
            disabled={props.customerInformations.phoneValidationCheck}
            InputProps={{
              inputComponent: VKNMask,
            }}
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <p className={classes.p}>
          {inputData.appType.value === "2"
            ? "Ortak T.C. Kimlik Numarası"
            : "T.C. Kimlik Numarası"}{" "}
        </p>
        <BaseTextField
          error={inputData.tckn.error}
          helperText={inputData.tckn.helperText}
          value={inputData.tckn.value}
          onChange={(ev) => inputDataChange("tckn", ev.target.value)}
          disabled={props.customerInformations.phoneValidationCheck}
          InputProps={{
            inputComponent: TCKNMask,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <p className={classes.p}>Doğum Tarihi</p>
        <DatePicker
          obj={inputData.birthDate}
          propName={"birthDate"}
          placeholder={"Date of Birth"}
          emptyLabel="put your here placeholder"
          setInputData={setInputData}
          disabled={props.customerInformations.phoneValidationCheck}
          onChange={(date) => inputDataChange("birthDate", date, "date")}
          invalidDateMessage={getErrorMessage("MS0005")}
          validationCheckError={inputData.birthDate.error}
        />
      </Grid>
      <Grid item xs={12}>
        <p className={classes.p}>Cep Telefonu</p>

        <BaseTextField
          error={inputData.phone.error}
          helperText={inputData.phone.helperText}
          value={inputData.phone.value}
          onChange={(ev) => inputDataChange("phone", ev.target.value)}
          disabled={props.customerInformations.phoneValidationCheck}
          InputProps={{
            inputComponent: PhoneNumberMask,
            endAdornment: (
              <InputAdornment position="end">
                {props.customerInformations.phoneValidationCheck ? (
                  <IconButton>
                    <CheckCircleOutlineIcon style={{ color: "#5cb85c" }} />
                  </IconButton>
                ) : (
                  <Button
                    variant="contained"
                    color={"primary"}
                    size={"small"}
                    onClick={() => verifyWithOtp("SMS")}
                    title={"Doğrula"}
                    style={{ textTransform: "none" }}
                  >
                    Doğrula
                  </Button>
                )}
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <p className={classes.p}>E-mail</p>
        <BaseTextField
          error={inputData.email.error}
          helperText={inputData.email.helperText}
          value={inputData.email.value}
          disabled={props.customerInformations.mailValidationCheck}
          type="email"
          onChange={(ev) => inputDataChange("email", ev.target.value)}
          InputProps={
            {
              /*endAdornment: (
              <InputAdornment position="end">
                {props.customerInformations.mailValidationCheck ? (
                  <IconButton>
                    <CheckCircleOutlineIcon style={{ color: "#5cb85c" }} />
                  </IconButton>
                ) : (
                  <Button
                    variant="contained"
                    color={"primary"}
                    size={"small"}
                    onClick={() => verifyWithOtp("MAIL")}
                    title={"Doğrula"}
                    style={{ textTransform: "none" }}
                  >
                    Doğrula
                  </Button>
                )}
              </InputAdornment>
            ),*/
            }
          }
        />
      </Grid>

      <div style={{ display: "flex", marginTop: 15 }}>
        <InfoIcon
          fontSize="small"
          color="disabled"
          style={{ marginRight: 5 }}
        />
        <div className={classes.informationLabel}>
          T.C. kimlik numaranız, cep telefonu numaranız ve doğum tarihiniz
          Fibabanka {getProductTypeString(props.processContext?.productType)}{" "}
          Kredisi başvurunuzun ön değerlendirmesinin yapılması ve bilgilerinizin
          doğrulanması amacıyla istenmektedir.{" "}
          <u>
            <b>
              Cep telefonunuza ya da Fibabanka mobil uygulamanıza doğrulama kodu
              gönderilecektir.
            </b>
          </u>
        </div>
      </div>
      <Grid item xs={12}>
        <FormControl
          required
          error={inputData.kisiselVerilerCheckBox.error}
          component="fieldset"
          className={classes.formControl}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={inputData.kisiselVerilerCheckBox.value}
                onChange={(ev) => {
                  if (!kvkkEnabled) {
                    linkRef.current.click();
                    /*props.actions.updateAlert({
                      severity: "error",
                      text: "Öncelikle 'Kişisel Verilerin Korunması ve İşlenmesi Hakkında Bilgilendirme Metni'ni okudum' linkine tıklayınız.",
                      open: true,
                    });*/
                  } else {
                    inputDataChange(
                      "kisiselVerilerCheckBox",
                      ev.target.checked,
                    );
                  }
                }}
                color={"primary"}
              />
            }
            label={
              <p className={classes.p}>
                <Link
                  href="https://fibabanka.com.tr/pdf/kvkk.pdf"
                  target="_blank"
                  ref={linkRef}
                  rel="noopener noreferrer"
                  onClick={() => {
                    setKvkkEnabled(true);
                    inputDataChange("kisiselVerilerCheckBox", true);
                  }}
                >
                  Kişisel Verilerin Korunması ve İşlenmesi Hakkında
                  Bilgilendirme Metni'ni okudum.
                </Link>
              </p>
            }
          />
          <FormHelperText>
            {inputData.kisiselVerilerCheckBox.helperText}
          </FormHelperText>
        </FormControl>
      </Grid>
      <Grid container item style={{ marginTop: 30 }}>
        <Button
          variant="contained"
          color="default"
          size="small"
          className={classes.button}
          onClick={temizleClick}
        >
          Temizle
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          onClick={devamClick}
        >
          Devam
        </Button>
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    customerInformations: state.customerInformations,
    processContext: state.processContext,
    alert: state.alert,
    global: state.global,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      updateCustomerInfo: bindActionCreators(updateCustomerInfo, dispatch),
      sendApplicantCompany: bindActionCreators(sendApplicantCompany, dispatch),
      updateUnsuccessMsg: bindActionCreators(updateUnsuccessMsg, dispatch),
      updateUnsuccessRedirectUrl: bindActionCreators(
        updateUnsuccessRedirectUrl,
        dispatch,
      ),
      addProcessContext: bindActionCreators(addProcessContext, dispatch),
      generateOTPApplicant: bindActionCreators(generateOTPApplicant, dispatch),
      updateAlert: bindActionCreators(updateAlert, dispatch),
      getProductInfo: bindActionCreators(getProductInfo, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LimitedStep1);
